export enum Status {
  PENDING_VERIFICATION = 'PENDING_VERIFICATION',
  ACTIVE = 'ACTIVE',
  RUNOFF = 'RUNOFF',
  DISABLED = 'DISABLED',
}

/** A gateway can receive new-sale work only while it is fully active. */
export function isEligibleForNewSales(status: Status): boolean {
  return status === Status.ACTIVE;
}

/** Existing assignments remain serviceable during runoff, but never after disablement. */
export function isEligibleForAssignedOperations(status: Status): boolean {
  return status === Status.ACTIVE || status === Status.RUNOFF;
}

const ALLOWED_TRANSITIONS: Readonly<Record<Status, readonly Status[]>> = {
  [Status.PENDING_VERIFICATION]: [Status.ACTIVE, Status.DISABLED],
  [Status.ACTIVE]: [Status.RUNOFF, Status.DISABLED],
  [Status.RUNOFF]: [Status.ACTIVE, Status.DISABLED],
  [Status.DISABLED]: [],
};

/**
 * Returns whether a lifecycle transition is valid at the domain boundary.
 * Reapplying the current state is intentionally idempotent.
 *
 * RUNOFF -> ACTIVE supports the credential-verified legacy configuration restore flow.
 * DISABLED is terminal until a dedicated reactivation workflow is introduced.
 */
export function canTransitionGatewayStatus(from: Status, to: Status): boolean {
  return from === to || ALLOWED_TRANSITIONS[from].includes(to);
}
